import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    cursor: 'pointer',
    padding: pxToRem(16),
    width: '100%',
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette.neutralLighter,
        textDecoration: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.neutralLight,
        textDecoration: 'none',
      },
    },
  },
  iconContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: pxToRem(16),
    height: pxToRem(20),
    width: pxToRem(20),
  },
  labelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  label: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: theme.palette.black,
  },
  secondaryLabelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginRight: pxToRem(40),
  },
  tertiaryLabelContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginRight: pxToRem(40),
  },
  description: {
    fontSize: pxToRem(12),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
  actionIndicator: {
    fontSize: pxToRem(20),
    color: theme.palette.red,
    selectors: {
      '& .ms-Icon': {
        fontSize: pxToRem(18),
        position: 'absolute',
        right: pxToRem(21),
      },
    },
  },
});
